import Store from "@hub/core/src/store"

const saveToLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data))
}

const getItemFromLocalStorage = key => {
  return JSON.parse(localStorage.getItem(key))
}

const removeItemFromLocalStorage = key => {
  localStorage.removeItem(key)
}

const itemExists = item => Boolean(item)

const getDiffHours = (date1, date2) => {
  const diff = Math.abs(date1 - date2)
  return Math.ceil(diff / (1000 * 60 * 60))
}

const calculateDiffHoursBetweenDates = date => {
  const now = new Date()
  return getDiffHours(now, date)
}

const sessionExpired = session => {
  const diffHours = calculateDiffHoursBetweenDates(new Date(session.createdAt))
  return diffHours > session.user.security.auth.maximum_offline_session
}

const sessionIsValid = session => {
  return itemExists(session) && !sessionExpired(session)
}

const updateStateLogin = session => {
  Store.dispatch("Auth/updateStateLogin", session)
}

const removeSessionFromLocalStorage = () => {
  removeItemFromLocalStorage("session")
}

const handleValidateSession = session => {
  if (sessionIsValid(session)) {
    updateStateLogin(session)
    return true
  }

  removeSessionFromLocalStorage()
  return false
}

export const saveSessionToLocalStorage = data => {
  saveToLocalStorage("session", {
    ...data,
    createdAt: new Date()
  })
}

export const getSessionFromLocalStorage = () => {
  let hasSession = false

  if (!navigator.onLine) {
    const session = getItemFromLocalStorage("session")
    hasSession = handleValidateSession(session)
  }

  return hasSession
}
